(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const cards = [...root.querySelectorAll('[data-nf-card]')];
    const buttons = [...root.querySelectorAll('[data-nf-category]')];
    const input = root.querySelector('[data-nf-search]');
    const counter = root.querySelector('[data-nf-count]');
    const empty = root.querySelector('[data-nf-empty]');
    const sort = root.querySelector('[data-nf-sort]');
    const grid = root.querySelector('[data-nf-grid]');
    const normalize = (text) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const categories = (card) => card.dataset.categories.split(' ');
    let category = 'all';
    cards.forEach((card, i) => { card.dataset.originalIndex = i; });
    buttons.forEach((button) => {
      const count = button.dataset.nfCategory === 'all' ? cards.length : cards.filter((card) => categories(card).includes(button.dataset.nfCategory)).length;
      button.querySelector('span').textContent = count;
      button.hidden = count === 0 && button.dataset.nfCategory !== 'all';
    });
    root.querySelectorAll('[data-nf-enhanced]').forEach((element) => { element.hidden = false; });
    root.querySelector('[data-nf-sort-submit]').hidden = true;
    function update(writeUrl = true) {
      const tokens = normalize(input.value).split(' ').filter(Boolean);
      let count = 0;
      cards.forEach((card) => {
        const match = (category === 'all' || categories(card).includes(category)) && tokens.every((token) => normalize(card.dataset.search).includes(token));
        card.hidden = !match;
        if (match) count++;
      });
      buttons.forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.nfCategory === category)); });
      counter.textContent = counter.dataset.template.replace('__COUNT__', String(count)).replace('__TOTAL__', String(cards.length));
      empty.hidden = count > 0;
      root.querySelector('.nf-catalog__results [data-nf-reset]').hidden = category === 'all' && !input.value;
      if (writeUrl) {
        const url = new URL(location.href);
        category === 'all' ? url.searchParams.delete('nf_category') : url.searchParams.set('nf_category', category);
        input.value.trim() ? url.searchParams.set('nf_search', input.value.trim()) : url.searchParams.delete('nf_search');
        history.replaceState(history.state, '', url);
      }
    }
    function restore() {
      const url = new URL(location.href);
      const requested = url.searchParams.get('nf_category');
      category = buttons.some((button) => button.dataset.nfCategory === requested && !button.hidden) ? requested : 'all';
      input.value = url.searchParams.get('nf_search') || '';
      update(false);
    }
    buttons.forEach((button) => { button.addEventListener('click', () => { category = button.dataset.nfCategory; update(); }); });
    input.addEventListener('input', () => update());
    root.querySelectorAll('[data-nf-reset]').forEach((button) => { button.addEventListener('click', () => { category = 'all'; input.value = ''; update(); input.focus(); }); });
    sort.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.assign(url.href);
    });
    root.addEventListener('submit', (event) => {
      if (event.target === sort.form) {
        event.preventDefault();
        sort.dispatchEvent(new Event('change'));
      }
    });
    restore();
  }
  function scan(scope) { scope.querySelectorAll('[data-nf-catalog]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
